<template>
    <Modal :show="show" @close="close()">

        <ModalSuccess v-if="success" :title="successTitle" :bodyText="successMessage" buttonText="Close window" @close="close()"/>



        <template v-if="step == 'REDEEM_TYPE'">

            <div class="modal-body">

                <div class="modal-header text-center">

                    <!--<h2 class="modal-title">Redeem a kit</h2>-->
                    <p class="w-100 titleText" v-if="isActivation">Please select one of the following options to proceed</p>
                    <p class="w-100 titleText" v-else>Please select one of the following options to redeem a kit</p>

                </div>

                <div class="modal-footer">
                    <div class="row mb-4">
                        <div class="col-sm-12 mb-sm-1" :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_SEND'}"
                               href="#" @click.prevent="setOption('REDEEM_SEND')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                     <img class="optImg" src="static/send-now-icon.svg">
                                </div>
                                <div>
                                    Send this kit to me now
                                </div>
                            </a>
                        </div>
                        <div class=" col-sm-12 mb-sm-1" :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_SEND_LATER'}"
                               href="#" @click.prevent="setOption('REDEEM_SEND_LATER')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                    <img class="optImg" src="static/send-later-icon.svg">
                                </div>
                                <div>
                                    Send this kit to me later
                                </div>
                            </a>
                        </div>
                        <div class="col-md-3 col-sm-12 mb-sm-1" v-if="showChildOption">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_CHILD'}"
                               href="#" @click.prevent="setOption('REDEEM_CHILD')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                    <img class="optImg" src="static/send-tokid-icon.svg">
                                </div>
                                <div>
                                    This kit is for my child/dependant
                                </div>
                            </a>
                        </div>
                        <div class=" col-sm-12 mb-sm-1"  :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_GIVE'}"
                               href="#" @click.prevent="setOption('REDEEM_GIVE')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                <img class="optImg" src="static/send-to_someone.svg">
                                </div>
                                <div>
                                    Give this kit to someone else
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a class="btn btn-primary" href="#" @click.prevent="setTabFromOption">Proceed</a>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="!isActivation">
                        <div class="col-12 buyText">
                            Haven’t purchased or been given a kit yet? <a href="#" @click.prevent="openBuy">Buy a kit for my journey</a>
                        </div>
                    </div>
                </div>

            </div>

        </template>
        <template v-if="step == 'REDEEM_CODE' || step == 'REDEEM_CODE_WITH_ADDRESS'">
            <div class="modal-body" v-if="!success">

                <div v-if="!error" class="modal-main mb-3">
                    <div class="modal-header">

                        <h2 v-if="isActivation" class="modal-title">Activate this kit</h2>
                        <h2 v-else class="modal-title">Redeem a kit</h2>
                    </div>
                </div>

                <transition name="slide-fade">
                    <div v-if="error" class="alert alert-danger" role="alert">
                        {{error}}
                    </div>
                </transition>

                <div class="row">
                    <div class="col-12">
                        <label for="voucher" class="h6">Enter your voucher code</label>
                        <p class="voucherSubtitle">If you have purchased or been given a kit, you will have been supplied a voucher code in an email.</p>
                        <input v-model="voucher" id="voucher" type="text" class="share-voucher"
                               placeholder="Voucher code"/>
                    </div>
                </div>


                <template v-if="step == 'REDEEM_CODE_WITH_ADDRESS'">
                    <ModalAddress ref="address" v-model.sync="editedUser" :noNameChange="true" />
                </template>

                <div class="row text-center mt-3">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="onRedeem"  :class="errors.items && errors.items.length ? 'disabled':''"
                           :disabled="errors.any() || !canSubmit">Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>


            </div>
        </template>
        <template v-if="step == 'REDEEM_CONSENT'">

            <div class="modal-body">
                <h2 class="modal-title text-left w-100">Reminder</h2>

                <p>For privacy reasons, each individual needs to have their own Microba account. A unique email address is required for each Microba account. We do not allow multiple users under a single Microba account in order to avoid incorrect assignment of results to an individual. If you are a parent/guardian and have already used this account for one child or other dependant, you cannot use this account for another individual.</p>
                <p>If you want to redeem this kit for a new minor or a dependant, you need to log out and create a new account for that individual. When you create a new account, you will need to select the parent/guardian or minor account type. </p>

                <div class="row text-center mt-5">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="onRedeem"
                           :disabled="errors.any() || !canSubmit">Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>
            </div>
        </template>
        <template v-if="step == 'REDEEM_ADDRESS'">


            <div class="modal-main ">
                <div class="modal-header">

                    <h2 class="modal-title">Confirm shipping and send kit</h2>
                    <p class="text-center w-100">The details must reflect the individual who is using this account to undertake their Microba tests.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <ModalAddress ref="address" v-model.sync="editedUser" :hideNameChange="true" />
                </div>
            </div>
            <div class="row w-100">
                <div class="col-6 text-right">
                    <a class="btn btn-primary" href="#" v-on:click.prevent="sendNow"
                       :disabled="errors.any() || !canSubmit">Send now</a>
                </div>
                <div class="col-6 text-left">
                    <a class="btn btn-outline-primary" href="#" v-on:click.prevent="sendLater"
                       :disabled="errors.any() || !canSubmit">Send later</a>
                </div>
            </div>

            <div class="row w-100 text-center mt-3">
                <div class="col-12">
                    <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                </div>
            </div>

        </template>
        <template v-if="step == 'REDEEM_REJECT'">
            <div  class="modal-main ">
                <div class="modal-header">

                    <h2 class="modal-title text-left text-center mb-3">Sorry you cannot do this</h2>
                    <p class="text-center">You currently have an ‘Adult’ account type which is for use by you (one adult) only. This account type cannot redeem a kit for others including a child/dependant. For privacy reasons, all individuals using Microba’s services are required to have their own Microba account with a unique email address.</p>
                    <p class="text-center">To manage an account on behalf of a child or dependant please create a separate Parent/Guardian account.</p>
                </div>


                <div class="row text-center mt-3">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="logout"
                           :disabled="errors.any() || !canSubmit">Log out and create a new account</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>
            </div>

        </template>
        <template v-if="step == 'REDEEM_GIVE'">
            <div  class="modal-main ">
                <div class="modal-header">

                    <h2 class="modal-title text-left mb-3 text-center">One individual per account</h2>
                    <p class="text-center">For privacy reasons, all individuals using Microba’s services are required to have their own Microba account with a unique email address. This includes minors and other dependants.</p>
                    <p class="text-center">A Parent/Guardian account will need to be created to redeem this kit successfully to begin their Journey.</p>
                </div>


                <div class="row text-center mt-3">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="openGive" >Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>
            </div>

        </template>


        <ModalSendAKit :kitID="getKitId" :show="showSendModal" :voucherCode="voucher" @close="showSendModal = false" />
        <ModalOrder
                :show="showReplacementModal"
                :product="replacementKitProduct"
                :showIntro="false"
                heading=""

                title="Confirm your details"
                copy="Please confirm your details below"
                @close="showReplacementModal = false"
        />
    </Modal>
</template>

<script>
  import Modal from '@/components/models/Modal'
  import ModalSuccess from '@/components/models/components/ModalSuccess'
  import ModalAddress from '@/components/models/components/ModalAddress'
  import ModalSendAKit from '@/components/models/ModalSendAKit'
  import ModalOrder from '@/components/models/ModalOrder'
  import UserMixins from '@/mixins/userProfile'

  export default {
    name: 'ModalRedeemKit',
    props: ['kitID', 'activateModal', 'slide'],
    mixins: [UserMixins],
    extends: Modal,
    components: {
      Modal,
      ModalAddress,
      ModalSuccess,
      ModalSendAKit,
      ModalOrder
    },
    mounted: function () {
      this.editedUser = this.user
    },
    data: function () {
      return {
        isEditing: false,
        voucher: '',
        selectedKit: null,
        step: 'REDEEM_TYPE',
        option: null,
        loading: false,
        success: false,
        error: null,
        showSendModal: false,
        showReplacementModal: false,
        radioButtonValue: null,
        replacementKitProduct: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        },
        editedUser: {
          firstName: '',
          lastName: '',
          addressLine1: '',
          addressLine2: '',
          suburb: '',
          postcode: ''
        },
        activate: true
      }
    },
    computed: {
      isActivation () {
        return this.activateModal
      },
      optionSpacing () {
        if (this.showChildOption) {
          return 'col-md-3'
        }
        return 'col-md-4'
      },
      showChildOption () {
        return !this.user.underAge && !this.user.guardian
      },
      getKitId () {
        if (this.selectedKit) {
          return this.selectedKit.kitId
        }
        return ''
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE || false
      },
      canSubmit: function () {
        return this.isValidAddress(this.editedUser) && this.voucher !== ''
      },
      successTitle () {
        if (this.activate) {
          return 'Great news, your kit is on its way!'
        }
        return 'Kit successfully redeemed'
      },
      successMessage () {
        if (this.activate) {
          return ''
        }
        return 'This kit is now available. Click "Select option" when you are ready to send this kit.'
      }
    },
    methods: {
      setOption (option) {
        this.option = option
//        this.step = step
      },
      setTab (type) {
        this.step = type
      },
      setTabFromOption () {
        if (this.option === 'REDEEM_SEND') {
          this.setTab('REDEEM_CODE_WITH_ADDRESS')
        } else if (this.option === 'REDEEM_SEND_LATER') {
          this.setTab('REDEEM_CODE')
        } else if (this.option === 'REDEEM_CHILD') {
          if (!this.user.underAge) {
            this.setTab('REDEEM_REJECT')
          } else {
            this.setTab('REDEEM_CODE')
          }
        } else if (this.option === 'REDEEM_GIVE') {
          this.setTab('REDEEM_CODE')
        }
      },
      onShow: function () {
        this.selectedKit = null
        this.option = null
        if (this.slide.length < 1) {
          this.step = 'REDEEM_TYPE'
        } else {
          this.step = this.slide
          if (this.step === 'REDEEM_CODE_WITH_ADDRESS') {
            this.option = 'REDEEM_SEND'
          } else {
            this.option = 'REDEEM_SEND_LATER'
          }
        }
        this.voucher = ''
        this.loading = false
        this.success = false
        this.error = null
        this.editedUser = Object.assign({}, this.user)
      },
      checkVoucher (type) {
        let self = this
        const payload = {
          voucher: this.voucher
        }

        this.$store.dispatch('checkVoucher', payload).then(success => {
          self.selectedKit = success.data

          if (type === 'GIVE') {
            self.openGive()
          } else if (type === 'SEND_TO_ME') {
            self.exeRedeem(self.selectedKit.kitId, true)
          } else if (type === 'SEND_LATER') {
            self.exeRedeem(self.selectedKit.kitId, false)
          } else if (type === 'REDEEM_CONSENT') {
            self.setTab('REDEEM_CONSENT')
          }
        }).catch(error => {
          console.log('ERROR', error)
          this.loading = false
          this.error = error.response.data.message
        })
      },
      onRedeem: function () {
        // Check code is valid
        if (this.option === 'REDEEM_SEND') {
          this.checkVoucher('SEND_TO_ME')
        } else if (this.option === 'REDEEM_SEND_LATER') {
          this.checkVoucher('SEND_LATER')
        } else if (this.option === 'REDEEM_CHILD') {
          if (this.step === 'REDEEM_CONSENT') {
            this.setTab('REDEEM_ADDRESS')
//            if (this.radioButtonValue === 'true') {
//              this.setTab('')
//            } else {
//              this.checkVoucher('GIVE')
//            }
          } else {
            this.checkVoucher('REDEEM_CONSENT')
          }
        } else if (this.option === 'REDEEM_GIVE') {
          this.checkVoucher('GIVE')
        }
      },
      openGive () {
        this.showSendModal = true
      },
      openBuy () {
        this.showReplacementModal = true
      },
      sendNow () {
        this.exeRedeem(this.selectedKit.kitId, true)
        this.setTab('')
      },
      sendLater () {
        this.exeRedeem(this.selectedKit.kitId, false)
        this.setTab('')
      },
      exeRedeem (code, activate) {
        this.activate = activate
        const payload = {
          kitId: code,
          addressLine1: this.editedUser.addressLine1,
          addressLine2: this.editedUser.addressLine2,
          suburb: this.editedUser.suburb,
          state: this.editedUser.state,
          postcode: this.editedUser.postcode,
          voucher: this.voucher,
          activate: activate
        }
        this.loading = true
        this.success = false
        this.error = null
        this.$store.dispatch('redeemKit', payload).then(success => {
          this.$store.dispatch('getUserKits')
          this.$store.dispatch('getSentKits')
          this.loading = false
          this.success = true
          this.$router.push({path: 'kits'})
        }).catch(error => {
          console.log(error)
          // Refresh regardless
          this.$store.dispatch('getUserKits')
          this.$store.dispatch('getSentKits')
          this.loading = false
          this.error = error.response.data.message
        })
      },
      logout: function () {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }

    },
    watch: {
      showSendModal () {
        if (this.showSendModal === false) {
          this.close()
        }
      },
      showReplacementModal () {
        if (this.showReplacementModal === false) {
          this.close()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .form {
        padding-top: 1rem;
        margin-top: 1rem;
    }

    .titleText {
        font-size:22px;
    }

    img {
        margin: 0px auto;
    }

    .btn-option {
        border: 1px solid #eaeaea;
        border-radius: 10px;
        white-space: normal;
        text-align: center;
        padding: 13px;
        font-size: 14px;
    }

    a.btn-option:hover {
        border: 2px solid #f08c35;
        box-shadow: 0px 0px 4px #ccc;
    }

    a.btn-option.active {
        color: #01b299;
        border: 2px solid #01b299;
        box-shadow: 0px 0px 4px #ccc;
    }

    a.btn-option.active .dot{
        display: inline-block;
    }

    .dot {
        position: absolute;
        top: -10px;
        right: 27px;
        display: none;
        height: 25px;
        width: 25px;
        background-color: #01b299;
        color: #fff;
        border-radius: 50%;
        padding-left: 1px;
        padding-top: 4px;
    }

    .radioHint{
        margin-left:30px;
        font-size:14px;
    }
    .flex-center-vertically {
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 400px;
    }

    .form-checkbox {
        label {
            color: #ff8708 !important;
        }
    }

    label {
        color: #ff8708 !important;
    }

    label.h6{
        color: #000 !important;
        margin-bottom:5px;
    }

    .optImg{
        max-width:100px;
    }

    .voucherSubtitle{
        font-size: 14px;
    }

    .modal-address {
        padding-top: 2rem;
        padding-bottom: 1.5rem;
    }

    .modal-header {
        img {
            margin-bottom: 2rem;
        }
    }

    .emParagraph{
        font-size:16px;
        font-weight: 500;
    }

    .buyText{
        font-size: .96rem;
        font-weight: lighter;
        line-height: 1.5;
    }
</style>



// WEBPACK FOOTER //
// src/components/models/ModalRedeemAKit.vue